import React from 'react';
import SpinnerIcon from '../../assets/svg/icon_spinner.svg';

const Spinner = () => {
  return (
    <div style={{ margin: '20px 0' }}>
      <SpinnerIcon />
    </div>
  );
};

export default Spinner;
